import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { motion } from "framer-motion";

const KuldeviPhotoPop = ({ open, onClose, productId, fetchImages }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [autoSlideIndex, setAutoSlideIndex] = useState(0);

  const getBase64Image = (img) => `data:image/jpeg;base64,${img}`;

  const loadImages = async () => {
    setIsLoading(true);
    try {
      const res = await fetchImages({ kuldevi_details_id: productId });
      if (res.status && Array.isArray(res.data)) {
        setImages(res.data);
        setSelectedImage(res.data[0]?.base64_image || "");
        setAutoSlideIndex(0);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (open && productId) {
      loadImages();
    }
  }, [open, productId]);

  useEffect(() => {
    if (images.length <= 1) return;
    const interval = setInterval(() => {
      setAutoSlideIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % images.length;
        const nextImage = (images[nextIndex]?.base64_image || "");
        setSelectedImage(nextImage);
        return nextIndex;
      });
    }, 3000);
    return () => clearInterval(interval);
  }, [images]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
         Images
        <IconButton onClick={onClose}>
          <CloseIcon color="error" />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {isLoading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={3}>
            {/* Thumbnail List */}
            <Grid item xs={12} md={2} sx={{ maxHeight: 400, overflowY: "auto" }}>
              <Grid container direction={{ xs: "row", md: "column" }} spacing={2}>
                {images.map((img, index) => {
                  const imgBase64 = (img.base64_image);
                  return (
                    <Grid item key={index}>
                      <Box
                        component={motion.img}
                        src={imgBase64}
                        alt={`thumb-${index}`}
                        onClick={() => {
                          setSelectedImage(imgBase64);
                          setAutoSlideIndex(index);
                        }}
                        sx={{
                          width: 80,
                          height: 80,
                          objectFit: "cover",
                          borderRadius: 2,
                          cursor: "pointer",
                          border:
                            selectedImage === imgBase64
                              ? "2px solid #1976d2"
                              : "1px solid #ccc",
                          boxShadow: 1,
                        }}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>

            {/* Main Image */}
            <Grid item xs={12} md={10}>
              {selectedImage && (
                <motion.img
                  key={selectedImage}
                  src={selectedImage}
                  alt="selected"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.5 }}
                  style={{
                    width: "100%",
                    height: "400px",
                    objectFit: "contain",
                    borderRadius: "12px",
                    boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
                  }}
                />
              )}
            </Grid>

            {/* Description */}
           
          </Grid>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default KuldeviPhotoPop;
